import React from "react";
import { connect } from "react-redux";
import "./MobilePreview.css";
import "./TabletPreview.css";

const PreviewWrapper = ({ device, children }) => {
  let style = device === "desktop" ? "" : device;
  return (
    <div className={style}>
      <div className="content-w">{children}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    device: state.template.previewDevice
  };
}
export default connect(mapStateToProps)(PreviewWrapper);
